export enum SunmiPrinterErrorCode {
    InvalidBase64 = 'ERR_SUNMI_INVALID_BASE64',
    PrinterUnavailable = 'ERR_SUNMI_PRINTER_UNAVAILABLE',
    ContextUnavailable = 'ERR_SUNMI_CONTEXT',
    PrinterOperation = 'ERR_SUNMI_PRINTER_OPERATION',
    PrinterDiscovery = 'ERR_SUNMI_PRINTER_DISCOVERY',
}
